import React, { useContext } from 'react';

import { SettingsContext } from 'contexts/SettingsContext';
import { QueryStringContext } from 'contexts/QueryStringContext';
import { Dropdown, NavLabel, Row, SubnavButton } from '../styles';

export class CompanySelect extends React.Component {
	state = {
		open: false,
	};

	componentDidMount() {
		const { setQueryStringStateAndPush, company, data } = this.props;

		if (!company) {
			setQueryStringStateAndPush({ company: data[0] });
		}
	}

	handleChangeOpen = open => {
		this.setState({ open });
	};

	handleChange = company => {
		const { setQueryStringStateAndPush } = this.props;

		setQueryStringStateAndPush({
			company,
		});
		this.setState({ open: false });
	};

	render() {
		const { data, company, disabled } = this.props;
		const { open } = this.state;
		const selectedCompany = company;

		return (
			<Dropdown
				label={selectedCompany}
				hideOpenLabel
				open={open}
				onChangeOpen={this.handleChangeOpen}
				disabled={disabled}
			>
				{data.map(item => (
					<SubnavButton
						key={item}
						title={item}
						onClick={() => this.handleChange(item)}
					>
						<Row>
							<NavLabel active={item === company}>{item}</NavLabel>
						</Row>
					</SubnavButton>
				))}
			</Dropdown>
		);
	}
}

export default React.memo(props => {
	const { companiesList } = useContext(SettingsContext);
	const { setQueryStringStateAndPush, company } = useContext(
		QueryStringContext
	);

	return (
		<CompanySelect
			{...props}
			data={companiesList}
			company={company}
			setQueryStringStateAndPush={setQueryStringStateAndPush}
		/>
	);
});
